import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const navLinks = [
    { to: '/', label: '首页' },
    { to: '/category/all', label: '电影分类' },
    { to: '/about', label: '关于我们' },
  ];

  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md'
          : 'bg-transparent'
      }`}
    >
      <div className="px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-18">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
            <div className="w-8 h-8 md:w-9 md:h-9 flex items-center justify-center">
              <i className="ri-movie-2-fill text-primary-500 text-2xl md:text-3xl"></i>
            </div>
            <span className="text-xl md:text-2xl font-bold font-heading text-foreground-50">
              天堂影院
            </span>
          </Link>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                  isActive(link.to)
                    ? 'text-primary-500'
                    : 'text-foreground-300 hover:text-foreground-50'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          {/* Search Bar (Desktop) */}
          <div className="hidden md:flex items-center gap-2 bg-background-100 rounded-full px-4 py-2 border border-background-300/60">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-search-line text-secondary-400 text-sm"></i>
            </div>
            <input
              type="text"
              placeholder="搜索电影..."
              className="bg-transparent text-sm text-foreground-200 placeholder-secondary-400 outline-none w-40"
            />
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-200 cursor-pointer"
            aria-label="菜单"
          >
            <i className={`text-xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-background-50/98 backdrop-blur-md border-t border-background-300/40">
          <div className="px-4 py-4 flex flex-col gap-3">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`text-sm font-medium py-2 whitespace-nowrap cursor-pointer ${
                  isActive(link.to)
                    ? 'text-primary-500'
                    : 'text-foreground-300 hover:text-foreground-50'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <div className="flex items-center gap-2 bg-background-100 rounded-full px-4 py-2 border border-background-300/60 mt-2">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-search-line text-secondary-400 text-sm"></i>
              </div>
              <input
                type="text"
                placeholder="搜索电影..."
                className="bg-transparent text-sm text-foreground-200 placeholder-secondary-400 outline-none w-full"
              />
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}